module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-5@3x.jpg?3721b428";